import { ChevronLeftIcon, ExclamationIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useState } from "react";
import { CheckIcon, ClockIcon, EyeIcon } from "@heroicons/react/outline";
import SessionModel from "../../api/models/SessionModel";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import RequestInfoModal from "../modal/RequestInfoModal";
import { RequestsType } from "../../api/@types/globalTypes";

type RequestsTableProps = {
  requests: RequestsType[];
};
export const TutorsTable = (props: RequestsTableProps) => {
  const { requests } = props;
  const LocalBasePath = "page.supervisor.sessions";
  const { t, i18n } = useTranslation("", { keyPrefix: LocalBasePath });
  const [open, setOpen] = useState<boolean>(false);
  const [request, setRequest] = useState<any>({});
  const [requestLabel, setRequestLabel] = useState<string>("");
  const [type, setType] = useState<string>("");

  return (
    <div className="mt-2 bg-white md:mt-0">
      <table className="min-w-full border-gray-200 table-fixed border-y">
        <thead className="bg-gray-50 ">
          <tr className="">
            <th
              scope="col"
              className=" px-3  py-3.5 text-justify text-sm font-semibold text-gray-500"
            >
              {t("request")}
            </th>
            <th
              scope="col"
              className=" px-3  py-3.5 text-justify   hidden sm:table-cell text-sm font-semibold text-gray-500"
            >
              {t("fromTutorSend")}
            </th>

            <th
              scope="col"
              className="py-3.5 ps-4 pe-3  text-justify text-sm font-semibold text-gray-500 sm:ps-6 hidden md:table-cell"
            >
              {t("toStudentSend")}
            </th>

            <th
              scope="col"
              className="px-3 py-3.5 text-justify text-sm font-semibold text-gray-500 hidden md:table-cell"
            >
              {t("requestTime")}
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-justify text-sm font-semibold text-gray-500 "
            >
              {t("requestStatus")}
            </th>
            <th scope="col" className="py-3.5 ps-3 pe-4 sm:pe-6">
              <span className="sr-only">More options</span>
            </th>
          </tr>
        </thead>
        <tbody data-cy="studentsTable">
          <>
            {requests.map((requestInfo, index) => {
              return (
                <>
                  <tr
                    key={`SessionInfoTable_${index}_${requestInfo.id}`}
                    className={" border-t cursor-pointer hover:bg-gray-50"}
                    onClick={() => {
                      setOpen(true);
                      setRequest(requestInfo);
                    }}
                  >
                    <td className="px-3 py-3.5">
                      <div className="flex gap-3 pe-4">
                        <div className="flex flex-col items-start gap-1">
                          <p className="text-xs leading-[18px] font-medium rounded-[10px] px-2.5 py-0.5 bg-gray-100 text-gray-800">
                            {t(requestInfo?.request_type)}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-3 hidden sm:table-cell py-3.5">
                      <div className="flex gap-3 pe-4 ">
                        <UserProfilePictureAvatar
                          profilePictureUrl={
                            requestInfo?.sender?.profile_picture_url
                          }
                          className="w-10 h-10"
                          alt="sand-tutor-img"
                        />
                        <div className="flex items-center ">
                          <h3 className="text-sm  text-[#6B7280]">
                            {requestInfo?.sender?.first_name +
                              " " +
                              requestInfo?.sender?.last_name}
                          </h3>
                        </div>
                      </div>
                    </td>
                    <td className="px-3  hidden sm:table-cell py-3.5">
                      <div className="flex gap-3 pe-4 ">
                        <UserProfilePictureAvatar
                          profilePictureUrl={
                            requestInfo?.receiver?.profile_picture_url
                          }
                          className="w-10 h-10"
                          alt="sand-user-img"
                        />
                        <div className="flex items-center ">
                          <h3 className="text-sm  text-[#6B7280]">
                            {requestInfo?.receiver?.first_name +
                              " " +
                              requestInfo?.receiver?.last_name}
                          </h3>
                        </div>
                      </div>
                    </td>

                    <td className="px-3 py-3.5 text-sm text-gray-500 hidden md:table-cell ">
                      {moment(requestInfo?.created_at).format("HH:mm A")}
                    </td>

                    <td className="px-3 py-3.5    ">
                      {requestInfo?.status === "approved" ? (
                        <span className="border-green-500 gap-1 border text-green-500 flex justify-center items-center flex-nowrap   text-xs font-medium py-1 px-2.5 rounded-xl">
                          <CheckIcon className="w-4 h-4 text-green-600" />
                          <p>{t("requestAccepted")}</p>
                        </span>
                      ) : requestInfo?.status === "rejected" ? (
                        <span className="border-red-600 gap-1 border text-red-600 flex justify-center items-center flex-nowrap   text-xs font-medium py-1 px-2.5  rounded-xl">
                          <ExclamationIcon className="w-4 h-4 text-red-600" />
                          <p>{t("requestCanceled")}</p>
                        </span>
                      ) : (
                        <span className="flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium text-gray-400 border border-gray-400 flex-nowrap rounded-xl">
                          <ClockIcon className="w-4 h-4 text-gray-400" />
                          <p>{t("requestPending")}</p>
                        </span>
                      )}
                    </td>
                    <td className=" px-3 py-3.5 text-sm text-gray-500">
                      <div className="flex justify-end">
                        <ChevronLeftIcon
                          className="w-4 h-4 text-gray-900 ltr:rotate-180"
                          aria-hidden="true"
                        />
                      </div>
                    </td>
                  </tr>
                </>
              );
            })}
          </>
        </tbody>
      </table>
      <RequestInfoModal
        open={open}
        onClose={() => setOpen(false)}
        id={request?.id}
        type={request?.request_type}
        setIsOpen={() => setOpen(false)}
        cancel={open}
      />
    </div>
  );
};
